  export const buildDateSequence = (start: Date, end: Date, approximate: boolean): string[] => {
    const dateList: string[] = [];
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();
    const sampleDays = [1, 10, 20, 28];

    for (let yr = startYear; yr <= endYear; yr++) {
      for (let mon = 0; mon < 12; mon++) {
        const monthDays = new Date(yr, mon + 1, 0).getDate();

        if (approximate) {
          sampleDays.forEach((day) => {
            if (day <= monthDays) {
              const date = new Date(yr, mon, day);
              if (date >= start && date <= end) {
                dateList.push(date.toISOString());
              }
            }
          });
        } else {
          for (let day = 1; day <= monthDays; day++) {
            const date = new Date(yr, mon, day);
            if (date >= start && date <= end) {
              dateList.push(date.toISOString());
            }
          }
        }
      }
    }

    return dateList;
  };
